import { SiteType } from "../../store/sites/Type";

export const filterSites = (orgId: string, list: SiteType[]) =>
    list.filter((item) => orgId === "none" || orgId === "all" || item.organisationId === parseInt(orgId));

